module.exports = __webpack_public_path__ + "static/media/gi.1afed1e4.svg";